module.exports = __webpack_public_path__ + "static/media/astro.64231d60.webp";